import { ref, onBeforeUnmount } from 'vue';

/**
 * QUELLE ENTRÉE DE MENU EST « LA NÔTRE » sur l'écran courant.
 *
 * Le menu latéral se surligne d'après le CHEMIN, ce qui suffit presque partout.
 * Presque : une mission client s'ouvre sur `/projets/:id`, comme un projet — les
 * deux écrans partagent la même fiche, c'est même tout l'intérêt du modèle. Le
 * menu retombait donc sur « Projets » alors qu'on venait de « Missions client »,
 * et on avait l'impression d'avoir changé de rayon en ouvrant une fiche.
 *
 * On ne devine pas depuis le chemin, parce qu'il ne le dit pas : c'est l'écran
 * qui SAIT, une fois le projet chargé, et qui le déclare ici. Une seule valeur,
 * posée par un écran à la fois, effacée quand il part — pas un magasin de plus.
 */
const chemin = ref<string | null>(null);

/** Lu par la coquille de l'application. `null` = le chemin courant fait foi. */
export const cheminActifForce = chemin;

/**
 * À appeler depuis un écran qui doit surligner une AUTRE entrée que la sienne.
 * Le nettoyage est automatique au démontage : un écran qui part ne doit pas
 * laisser le menu pointer là où l'on n'est plus.
 */
export function useNavContext(): (chemin: string | null) => void {
  onBeforeUnmount(() => {
    chemin.value = null;
  });
  return (valeur: string | null) => {
    chemin.value = valeur;
  };
}
